import { CARTOON_POSTERS } from '../../../utils/helpers/intro/data';
import styles from './Slide3.module.css';
import SlideShell from './SlideShell';

export default function Slide3({ handleNext, handlePrev, current, total, t }) {
  return (
    <SlideShell handleNext={handleNext} handlePrev={handlePrev} current={current} total={total} t={t}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <p className={styles.title}>{t("intro_safe_joyful_cartoons_title")}</p>
          <p className={styles.text}>{t("intro_cartoons_safe_description")}</p>
        </div>
        <div className={styles.cartoons}>
          {CARTOON_POSTERS.map((img, index) => (
            <div key={index} className={styles.cartoonCard}>
              <img src={img} alt='' className={styles.cartoonImage} />
            </div>
          ))}
        </div>

        <div className={styles.badge}>
          <img src='/assets/intro/badge.svg' alt='' height={22} width={22} />
          <span>{t("ad_free_child_safe_environment")}</span>
        </div>
      </div>
    </SlideShell>
  );
}